// extracted by mini-css-extract-plugin
export default {"newContactButton":"agencies_newContactButton__QGGzr"};